interface Worker {
  lastName?: string;
  firstName?: string;
  patronymic?: string;
}

export function formatWorkersFio(workers: Worker[]): string {
  if (!workers || workers.length === 0) return '';

  return workers
    .map((w) => {
      const firstInitial = w.firstName ? `${w.firstName[0].toUpperCase()}.` : '';
      const patronymicInitial = w.patronymic ? `${w.patronymic[0].toUpperCase()}.` : '';
      return `${w.lastName} ${firstInitial}${patronymicInitial}`;
    })
    .join(', ');
}
